module.exports = __webpack_public_path__ + "img/scripted-sql.9354ff58.svg";